<template>
  <div class="banner-three-area">
    <div class="container mw-1685">
      <div class="position-relative z-1">
        <div
          class="banner-content-three"
          data-aos="fade-in"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <span class="top-title">بث مباشر ذكي بجودة فائقة</span>
          <h2>تجربة البث التلفزيوني المستقبلي الذي تبحث عنه</h2>
          <p>
            من الملاعب العالمية والبطولات الكبرى وحتى شاشتك مباشرة، استمتع بأقوى باقة قنوات وأفلام ومسلسلات بجودة 4K وثبات تام يضمن لك ولعائلتك تجربة مشاهدة لا تُنسى.
          </p>
          
          <!-- صندوق تواصل سريع يفتح واتساب مباشرة -->
          <form class="check-form position-relative" @submit.prevent="redirectToWhatsapp">
            <input
              type="text"
              class="form-control"
              placeholder="اكتب استفسارك أو طلب التجربة هنا..."
            />
            <button
              type="submit"
              class="btn active position-absolute top-50 start-0 translate-middle-y"
            >
              <span class="border-style">تواصل الآن</span>
            </button>
          </form>
          
          <p class="already">
            هل لديك اشتراك بالفعل وتبحث عن دعم؟
            <a href="https://wa.me/447429916178" target="_blank">اضغط هنا للتحدث معنا.</a>
          </p>
        </div>

        <div class="banner-shape banner-shape-1">
          <img src="@/assets/images/banner-shape-1.png" alt="banner-shape" />
          <img
            src="@/assets/images/shape-11.png"
            class="shape-11"
            alt="shape-11"
          />
          <img
            src="@/assets/images/shape-13.png"
            class="shape-13"
            alt="shape-13"
          />
        </div>
        <div class="banner-shape banner-shape-2">
          <img src="@/assets/images/banner-shape-2.png" alt="banner-shape" />
          <img
            src="@/assets/images/shape-12.png"
            class="shape-12"
            alt="shape-12"
          />
        </div>
        <img
          src="@/assets/images/banner-shape-3.png"
          class="banner-shape banner-shape-3"
          alt="banner-shape"
        />
        <div class="banner-shape banner-shape-4">
          <img src="@/assets/images/banner-shape-4.png" alt="banner-shape" />
          <img
            src="@/assets/images/shape-13.png"
            class="shape-13"
            alt="shape-13"
          />
        </div>
      </div>
    </div>

    <img
      src="@/assets/images/shape-14.png"
      class="shape-14 shape"
      alt="shape-14"
    />
    <img
      src="@/assets/images/shape-14.png"
      class="shape-15 shape"
      alt="shape-14"
    />
    <img
      src="@/assets/images/shape-14.png"
      class="shape-16 shape"
      alt="shape-14"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MainBannerThree", // تم تمييز الاسم لعدم التضارب مع البانر الأول
  setup() {
    const redirectToWhatsapp = () => {
      window.open("https://wa.me/447429916178", "_blank");
    };

    return {
      redirectToWhatsapp,
    };
  },
});
</script>